import React from 'react'
import { Modal } from 'reactstrap';
import AuthLoader from './AuthLoader';

const ConfirmationModal = ({ okButton, cancelButton, statusModal, setStatusModal, status, title, content, butttonName, icon, loader, cancelBtnName }) => {
     return (
        <div>
            <Modal
                isOpen={statusModal}
                toggle={() => {
                    setStatusModal(!statusModal);
                }}
                backdrop={'static'}
                centered
                id="staticBackdrop"
            >
                {/* <div className="modal-header border-0 p-0"> */}
                    <button type="button" className="btn-close" onClick={cancelButton} ></button>
                {/* </div> */}
                <div className={`modal-body ${status == "success" ? "active" :"deactive"}`}>
                   <div className='content text-center'>
                    {/* <div className='icon'>
                        <img src={icon} alt={title}/>
                    </div> */}
                    <div className='text'>
                    <h2 className="modal-title" id="staticBackdropLabel">{title}</h2>
                   <p> {content}</p>
                    </div>
                   </div>
                </div>
                <div className="modal-footer border-0 justify-content-center">
                     <button type="button" className="secountry-btn" onClick={cancelButton}>{cancelBtnName ? cancelBtnName : 'Cancel'}</button>
                    {loader === true ? <AuthLoader/> : <button type="button" className="primary-button" onClick={okButton}>{butttonName}</button>}
                </div>
            </Modal>
        </div>
    )
}

export default ConfirmationModal